import React, { Component } from 'react';
import {Link} from 'react-router';
import $ from 'jQuery';

// import camera from '../../../assets/js/camera.min.js'
export default class Menu extends Component {

  render() {
    return (
      <div className="top">
        <div className="navbar navbar-inverse navbar-fixed-top">
          <div className="container">
            <div className="navbar-header">
              <button type="button" className="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">
              <span className="icon-bar"></span><span className="icon-bar"></span><span className="icon-bar"></span></button>
              <a className="navbar-brand" href="/">
                <img src="assets/images/logo.png" alt="logo" className="img-responsive" /></a>
            </div>
            <div className="navbar-collapse collapse">
              <ul className="nav navbar-nav pull-right mainNav">
                <li className="active"><a href="/">Acasa</a></li>
                
                <li className="dropdown">
                  <a href="#" className="dropdown-toggle" data-toggle="dropdown">Despre noi <b className="caret"></b></a>
                  <ul className="dropdown-menu">
                    <li><a href="description">Descriere</a></li>
                    <li><a href="media">Articole media</a></li>
                  </ul>
                </li>

                <li className="dropdown">
                  <a href="#" className="dropdown-toggle" data-toggle="dropdown">Proiecte <b className="caret"></b></a>
                  <ul className="dropdown-menu">
                    <li><a href="projects">Proiecte finalizate</a></li>
                    <li><a href="futureprojects">Proiecte viitoare</a></li>
                  </ul>
                </li>

                <li><a href="center">Centrul de recuperare</a></li>
                <li><a href="christmas">Craciunei si craciunite</a></li>
                <li><a href="donate">Cum donam?</a></li>
                <li><a href="contact">Contact</a></li>

              </ul>
            </div>
          </div>
        </div>



        {/* end */}
      </div >
    );
  }
}



// WEBPACK FOOTER //
// ./app/screens/Main/menu.js